import { all, fork } from "@redux-saga/core/effects"

export default function* () {
    yield all(
        []
    )
}
